<digital-platform-rsx-a
  [url]="url[0].uri"
  klass="text-color-white text-decoration-none px-4 align-items-center"
  >{{ url[0].title }}</digital-platform-rsx-a
>
